import React, { useEffect } from 'react'
import { enums } from '@adc/sdk'
import {
  CognitionEvaluationGroup,
  CognitionEvaluationMethod,
  CognitionEvaluationGroupMessage,
} from '@adc/sdk/types'
import { cognition } from '@adc/blueprint'
// @ts-ignore no types
import {
  Text,
  CardContainer,
  CognitionMessage,
  // @ts-ignore no types
} from '@adc/ui-morpheus'
import classnames from 'classnames/bind'
import styles from './styles.scss'

const cx = classnames.bind(styles)

interface TraceProps {
  evalGroup: CognitionEvaluationGroup
  method: CognitionEvaluationMethod | null
  containerRef?: React.RefObject<HTMLDivElement>
}

const Trace: React.FC<TraceProps> = ({ evalGroup, method, containerRef }) => {
  const [errorMessage, setErrorMessage] = React.useState<string>('')
  const [messages, setMessages] = React.useState<
    CognitionEvaluationGroupMessage[]
  >([])

  useEffect(() => {
    if (!evalGroup) return

    setErrorMessage('')

    try {
      setMessages(
        cognition.utils.evaluationGroupUtils.getMessages(evalGroup, {
          includeProgress: true,
          includePrivateMessages: true,
          temporalInterimMessages: false,
        })[method || enums.CognitionEvaluationMethod.InitialMethod] || []
      )
    } catch (error) {
      console.error('Error fetching messages for method:', error)
      setErrorMessage('Error fetching messages for method.')
      setMessages([])
    }
  }, [evalGroup, method])

  return (
    <div className={cx('trace-container')} ref={containerRef}>
      {messages.length === 0 && (
        <CardContainer className={cx('placeholder')}>
          <Text color='gray'>
            No trace available for the selected evaluation method.
          </Text>
        </CardContainer>
      )}

      {errorMessage && (
        <CardContainer className={cx('placeholder')}>
          <Text color='gray'>{errorMessage}</Text>
        </CardContainer>
      )}

      {messages.length > 0 &&
        !errorMessage &&
        messages.map((message, index) => (
          <CognitionMessage
            key={index}
            message={message}
            mode='trace'
            index={index}
          />
        ))}
    </div>
  )
}

export default Trace
